import React from 'react';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-cream pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-12">
        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left z-10" data-id="element-13">
          <div className="inline-flex items-center justify-center px-4 py-1.5 mb-8 rounded-full border border-sage/30 bg-sage-light text-sage text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-14">
            THE NATURAL RESET PROTOCOL
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.15] mb-8 font-medium" data-id="element-15">
            Stop the 3 AM Wake-Ups, Lose the Belly Bloat, and Get Your Energy
            Back in 14 Days or Less
          </h1>

          <p className="text-lg md:text-xl text-warm-dark/80 mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-16">
            The Sovereignty Protocol for Women 35–60 who are tired of feeling
            foggy, exhausted, and stuck in a body that doesn't feel like
            theirs."
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-17">
            <Button href="https://activatureset.com/cart/52638683463972:1" className="w-full sm:w-auto" data-id="element-18">
              Yes! I Want The Protocol
            </Button>
            <span className="text-sm text-warm-dark/60 italic font-heading text-lg" data-id="element-19">
              Instant Download for $6.36
            </span>
          </div>
        </div>

        {/* Image Content */}
        <div className="flex-1 relative w-full max-w-md lg:max-w-full mx-auto" data-id="element-20">
          <div className="absolute inset-0 bg-sage-light rounded-full blur-3xl opacity-50 transform translate-x-10 translate-y-10" data-id="element-21"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ayQrPTTdoLPgAXL3Mt5A7E/Mockup_HS.jpg" alt="Hormonal Sovereignty Digital Protocol on Tablet and Phone" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-22" />
        </div>
      </div>
    </section>;
}